import {
	SimpleForm,
	ReferenceInput,
	SelectInput,
	TextInput,
	NumberInput,
	ImageInput,
	ImageField,
	LongTextInput,
	NullableBooleanInput
} from "react-admin";
import React from "react";
import { SUPERADMIN } from "../../constant/TypeRole";
import { required, isBool } from "../../services/validate";

const TypeForm = props => {
	const { record } = props;
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<SimpleForm {...props}>
			<ReferenceInput
				disabled={record.project ? true : false}
				validate={[required()]}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<TextInput source="name" label="ชื่อภาษาไทย" />
			<TextInput source="name_en" label="ชื่อภาษาอังกฤษ" />
			<TextInput source="name_jp" label="ชื่อภาษาญี่ปุ่น" />
			<TextInput source="name_zh" label="ชื่อภาษาจีน" />
			<NumberInput source="order" step={1} label="ลำดับ" />
			<NullableBooleanInput source="visible" label="แสดงรายการนี้" validate={[isBool()]} style={{ width: 256 }} />
		</SimpleForm>
	);
};

export default TypeForm;



// WEBPACK FOOTER //
// ./src/components/type/TypeForm.js